import React from "react";
import { Box } from "@mui/material";
import AdminSideNav from "../../../adminComponents/sidenav";
import AdminHeader from "../../../adminComponents/header";
import AuditHistory from "./AuditHistory";

const HistoryModule = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ml: { xs: "0px", md: "200px" },
        }}
      >
        <AdminSideNav />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <AdminHeader title={"Audit History"} />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 }
          }}
        >
          <AuditHistory />
        </Box>
      </Box>
    </Box>
  );
};

export default HistoryModule;
